import { Download, LoaderCircle } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { useArchiveDownload } from './useArchiveDownload';

const inlineAction = 'font-medium text-[var(--co-text)] underline hover:no-underline';

interface Props {
  packId: number;
  /** Nothing to put in the ZIP: no pack art and no cards. */
  disabled: boolean;
}

export function ArchiveButton({ packId, disabled }: Props) {
  const { state, start } = useArchiveDownload(packId);
  const preparing = state.phase === 'preparing';

  return (
    <div className="flex flex-col gap-1">
      <Button
        onClick={() => void start()}
        disabled={disabled || preparing}
        aria-busy={preparing}
        className="gap-2"
      >
        {preparing ? (
          <LoaderCircle size={16} className="animate-spin" aria-hidden="true" />
        ) : (
          <Download size={16} aria-hidden="true" />
        )}
        {preparing ? 'Preparing ZIP…' : 'Download all (ZIP)'}
      </Button>

      {preparing && (
        <p className="text-[12px] text-[var(--co-muted)]">This can take a minute for a large pack.</p>
      )}
      {state.phase === 'started' && (
        <p className="text-[12px] text-[var(--co-muted)]">
          Your download has started. Not seeing it?{' '}
          <button type="button" onClick={() => void start()} className={inlineAction}>
            Download again
          </button>
        </p>
      )}
      {state.phase === 'failed' && (
        <p role="alert" className="text-[12px] text-[var(--co-error)]">
          {state.message}{' '}
          <button type="button" onClick={() => void start()} className={inlineAction}>
            Try again
          </button>
        </p>
      )}
    </div>
  );
}
